// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"ba377ef2f9b81e4a0bf4","873":"e880991a73903ceadc19"}[chunkId] + ".js";
};